import { render, staticRenderFns } from "./teaching-resource-packs.vue?vue&type=template&id=94f254f6"
import script from "./teaching-resource-packs.vue?vue&type=script&lang=js"
export * from "./teaching-resource-packs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports